/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Section_AppearanceInputs */

const en_settings_section_appearance = /** @type {(inputs: Settings_Section_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appearance Settings`)
};

const de_settings_section_appearance = /** @type {(inputs: Settings_Section_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erscheinungsbild-Einstellungen`)
};

/**
* | output |
* | --- |
* | "Appearance Settings" |
*
* @param {Settings_Section_AppearanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_section_appearance = /** @type {((inputs?: Settings_Section_AppearanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Section_AppearanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_section_appearance(inputs)
	return de_settings_section_appearance(inputs)
});